import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allBillingData: [],
  entityDetails:null,
  sidebarLogo: null,
};

export const billingReducer = createSlice({
  name: "billing",
  initialState,
  reducers: {
    setAllBillingData: (state, action) => ({
      ...state,
      allBillingData: action.payload,
    }),
    setEntityData: (state, action) => ({
      ...state,
      entityDetails: action.payload,
    }),
    setSidebarLogo: (state, action) => ({
      ...state,
      sidebarLogo: action.payload,
    }),
  },
});

export const { setAllBillingData ,setEntityData, setSidebarLogo} = billingReducer.actions;
export default billingReducer.reducer;
